import { render, staticRenderFns } from "./TagInput.vue?vue&type=template&id=c6b67998&scoped=true"
import script from "./TagInput.vue?vue&type=script&lang=ts"
export * from "./TagInput.vue?vue&type=script&lang=ts"
import style0 from "./TagInput.vue?vue&type=style&index=0&id=c6b67998&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b67998",
  null
  
)

export default component.exports